module.exports = __webpack_public_path__ + "img/p3-2-1.9ead1ab2.png";